import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';
import { ChangeProspectClubDetails } from './classes/ChangeProspectClubDetails';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

const discover = () => {
  const hutkId = getCookie('hubspotutk');
  const token = hutkId === null ? '0' : hutkId;
  const url = apiConstants.discover;
  return httpClient.get(`${url}?token=${token}`).then((result) => result);
};

const changePreferredHomeClub = (token, newHomeClubId) => {
  const url = apiConstants.changePreferredHomeClub;
  const model = new ChangeProspectClubDetails(token, newHomeClubId);
  return httpClient.post(url, model).then((result) => result.data);
};

const changeHomeClub = (newHomeClubId) => {
  const url = apiConstants.changeHomeClub;

  return httpClient.post(url, { clubId: newHomeClubId }).then((result) => result.data);
};

export { discover, changePreferredHomeClub, changeHomeClub, getCookie };
